"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gamplayFormTranslator = void 0;
exports.gamplayFormTranslator = {
    en: {
        story: "Story",
        objectives: "Objectives",
        objectivesHint: "press enter to add",
        progression: "Progression",
        progressionHint: "press enter to add",
        difficulty: "Difficulty",
        pacing: "Pacing",
        player_experience: "Player Experience",
        save: "Saved",
        saveBtn: "Save",
    },
    ru: {
        story: "Описание",
        objectives: "Цели",
        objectivesHint: "нажмите Enter, чтобы добавить",
        progression: "Прогрессия",
        progressionHint: "нажмите Enter, чтобы добавить",
        difficulty: "Сложность",
        pacing: "Темп игры",
        player_experience: "Опыт игрока",
        save: "Сохранено",
        saveBtn: "Сохранить",
    },
};
